import api from '@/services/api';
import { make } from 'vuex-pathify';
import Vue from 'vue';
import { defaultEpsg, defaultSRID } from '@/assets/js/variables';
import { saveFileFromBackend } from '@/assets/js/utility';
const state = {
  externalSystems: [],
  availableSystems: [],
  connectedDataSources: {},

  dbGisSystems: [],
  availableDbGisSystems: [],

  dbGisBoxSystems: [],
  availableDbGisBoxSystems: [],
};
const mutations = {
  ...make.mutations(state),
  SET_CONNECTED: (state, value) => {
    const { dataSource, data } = value;
    Vue.set(state.connectedDataSources, dataSource, data);
  },
};
const actions = {
  async deleteConnection({ dispatch }, id) {
    await api.delete(`/external_systems/${id}`);
    await dispatch('getExternalSystems');
  },
  async addConnection({ dispatch }, payload) {
    await api.post(`/external_systems`, payload);
    console.log('added :', payload);
    await dispatch('getExternalSystems');
  },
  async editConnection({ dispatch }, payload) {
    const { id, body } = payload;
    await api.put(`/external_systems/${id}`, body);
    console.log('edited :', payload);
    await dispatch('getExternalSystems');
  },
  async getExternalSystems({ commit }) {
    const r = await api.get(`/external_systems`);
    commit('SET_EXTERNAL_SYSTEMS', r.data.data);
  },
  async getAvailableSystems({ commit }) {
    const r = await api.get(`/external_systems/available_systems `);
    commit('SET_AVAILABLE_SYSTEMS', r.data.data);
  },
  async checkDatasourceConnection({ commit }, dataSourceName) {
    try {
      const r = await api.get(`/external_systems/${dataSourceName}`, { skipDefaultErrorHandler: true });
      commit('SET_CONNECTED', { dataSource: dataSourceName, data: r.data.data });
    } catch (e) {
      console.warn(e.message);
    }
  },
  async getTableHeaders(store, system_id) {
    const r = await api.get(`/external_systems/${system_id}/metadata`);
    return r.data.data;
  },
  async getTableData(store, payload) {
    const { feature_id, datasource } = payload;
    const r = await api.get(`/external_systems/${datasource}/${feature_id}`);
    return r.data.data;
  },
  async getDbGisSystems({ commit }) {
    const r = await api.get(`/db2gis`);
    commit('SET_DB_GIS_SYSTEMS', r.data.data);
  },
  async getAvailableDbGisSystems({ commit }) {
    const r = await api.get(`/db2gis/available_systems `);
    commit('SET_AVAILABLE_DB_GIS_SYSTEMS', r.data.data);
  },
  async deleteDbGisConnection({ dispatch }, id) {
    await api.delete(`/db2gis/${id}`);
    await dispatch('getDbGisSystems');
  },
  async addDbGisConnection({ dispatch }, payload) {
    await api.post(`/db2gis`, payload);
    await dispatch('getDbGisSystems');
  },
  async editDbGisConnection({ dispatch }, payload) {
    const { id, body } = payload;
    await api.put(`/db2gis/${id}`, body);
    await dispatch('getDbGisSystems');
  },
  async refreshDbGisView(store, id) {
    await api.get(`/db2gis/migrate/${id} `);
  },
  async refreshKomadresData() {
    await api.get('komadres_orders/migrate');
  },
  async addKomadresOrder({ dispatch }, body) {
    await api.post('komadres_orders', body);
    await dispatch('refreshKomadresData');
  },
  async getKomadresOrderHistory(store, id) {
    const r = await api.get(`/komadres_orders/history/${id}`);
    return r.data.data;
  },
  async getSearchedArea(store, payload) {
    return (await api.post('/databox/investments/search', payload)).data.data;
  },
  async getDataBoxLayersMetadata(store, name) {
    const r = await api.get(`databox/layers/metadata/${name}`);
    return r.data.data;
  },
  async getUsableArea(store, payload) {
    return (
      await api.post('oze/usable_area', payload, {
        params: {
          background: true,
        },
      })
    ).data.tid;
  },
  async getProjectsStatuses(store, id) {
    return (await api.get(`oze/projects/${id}/tasks_summary`)).data.data;
  },
  async getActivitiesLog(store, data) {
    const { layerId, featureId, params = {} } = data;
    const r = await api.get(`v2/activities/${layerId}/${featureId}`, { params });
    return r.data.data;
  },
  async getActivitiesCount(store, data) {
    const { layerId, featureId, params = {} } = data;
    const r = await api.get(`v2/activities/${layerId}/${featureId}/count`, { params });
    return r.data.data;
  },
  async importPaihOffer(store, payload) {
    return (await api.post('paih/import_offer', payload)).data.data;
  },
  async exportPaihOffer(store, payload) {
    await api.post('paih/export_offer', payload);
  },

  async getDbGisBoxSystems({ commit }) {
    const r = await api.get(`/external_db/systems`);
    commit('SET_DB_GIS_BOX_SYSTEMS', r.data.data);
  },
  async getAvailableDbGisBoxSystems({ commit }) {
    const r = await api.get('/external_db/available_systems');
    commit('SET_AVAILABLE_DB_GIS_BOX_SYSTEMS', r.data.data);
  },
  async deleteDbGisBoxConnection({ dispatch }, id) {
    await api.delete(`/external_db/systems/${id}`);
    await dispatch('getDbGisBoxSystems');
  },
  async addDbGisBoxConnection({ dispatch }, payload) {
    await api.post(`/external_db/systems`, payload);
    await dispatch('getDbGisBoxSystems');
  },
  async editDbGisBoxConnection({ dispatch }, payload) {
    const { id, body } = payload;
    await api.put(`/external_db/systems/${id}`, body);
    await dispatch('getDbGisBoxSystems');
  },
  async refreshDbGisBoxView(store, id) {
    await api.get(`/external_db/systems/${id}/migrate`);
  },
  async getInsightsLocationAnalysis(store, payload) {
    const r = await api.post('/v2/insights/location_analysis', payload);
    return r.data.data;
  },
  async getRetailLocationAnalysis(store, payload) {
    const r = await api.post('/v2/retail/location_analysis', payload);
    return r.data.data;
  },
  async downloadDbGisBoxData(store, payload) {
    await api.post(`/databox/download_data`, payload);
  },
  async getDataboxData(store, payload) {
    const r = await api.post(`/databox/download_data_v2`, payload);
    return r.data.data;
  },
  async getDbGisBoxMetadata(store, params = {}) {
    return (await api.get('/databox/layers/metadata', { params })).data.data;
  },
  async getDataBoxDynamicBufferLayers() {
    return (await api.get('databox/dynamic_buffer/layers/metadata')).data.data;
  },
  async getDataboxDynamicBuffer(store, data) {
    const toolPaths = {
      buffer: 'databox/dynamic_buffer',
      advancedArea: 'databox/dynamic_buffer_v2',
    };

    const { target = 'buffer', payload } = data;
    const r = await api.post(toolPaths[target], payload);
    if (r.data.data?.features && !r.data.data?.features.length)
      throw new Error(`Invalid API response. Features array can not be empty: ${JSON.stringify(r.data.data)}`);
    return (
      (r.data.data?.features ?? []).reduce((total, current) => {
        const {
          properties: { layer },
        } = current;
        if (!total[layer]) {
          total[layer] = {
            crs: { properties: { name: defaultEpsg }, type: 'name' },
            features: [],
            type: 'FeatureCollection',
          };
        }
        total[layer].features.push(current);
        return total;
      }, {}) || {}
    );
  },
  async getDataboxIntersection(store, payload) {
    const r = await api.post('databox/intersect_features_by_layer', payload);
    return r.data.data;
  },
  async zoningOptimization(store, payload) {
    const r = await api.post('v2/zoning/optimization', payload, {
      headers: {
        'X-Request-SRID': defaultSRID,
      },
    });
    return r.data.data;
  },
  async zoningH3(store, payload) {
    const r = await api.post('v2/zoning/h3', payload, {
      headers: {
        'X-Request-SRID': defaultSRID,
      },
    });
    return r.data.data;
  },
  async zoningParsedFilter(store, filter) {
    const r = await api.post('v2/zoning/filter-parse', { filter_expression: filter });
    return r.data.data;
  },
  async getIlsDashboardUrl(store, selectedFeatures) {
    const r = await api.post('ils/dashboard', selectedFeatures);
    return r.data.data;
  },

  // TENTEC
  async getTentecMappings() {
    return (await api.get('v2/tentec-mappings')).data.data;
  },
  async addTentecMapping({ dispatch }, payload) {
    await api.post('v2/tentec-mappings', payload);
    return await dispatch('getTentecMappings');
  },
  async editTentecMapping({ dispatch }, { id, payload } = {}) {
    await api.put(`v2/tentec-mappings/${id}`, payload);
    return await dispatch('getTentecMappings');
  },
  async deleteTentecMapping({ dispatch }, id) {
    await api.delete(`v2/tentec-mappings/${id}`);
    return await dispatch('getTentecMappings');
  },
  async getTentecImports() {
    return (await api.get('v2/tentec-import/reports')).data.data;
  },
  async getTentecImportReport(store, id) {
    const r = await api.get(`v2/tentec-import/reports/${id}/pdf`, { responseType: 'arraybuffer' });
    saveFileFromBackend(r.data, r.headers);
  },
  async getTentecImportFile(store, id) {
    const r = await api.get(`v2/tentec-import/reports/${id}/data-file`, { responseType: 'arraybuffer' });
    saveFileFromBackend(r.data, r.headers);
  },
  async getTentecImportTemplate(store, id) {
    const r = await api.get(`v2/tentec-import/template/${id}`, { responseType: 'arraybuffer' });
    saveFileFromBackend(r.data, r.headers);
  },
  async tentecExportToEC(store, { id, payload }) {
    await api.post(`v2/tentec-export/${id}`, payload);
  },
  async deleteTentecExport(store, id) {
    await api.delete(`v2/tentec-export/${id}`);
  },
  async editTentecExport(store, { id, payload }) {
    await api.put(`v2/tentec-export/${id}`, payload);
  },
  async getTentecExports() {
    return (await api.get('v2/tentec-export')).data.data;
  },
  async getTentecExportReport(store, id) {
    const r = await api.get(`v2/tentec-export/${id}/pdf`, { responseType: 'arraybuffer' });
    saveFileFromBackend(r.data, r.headers);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
